import type { YieldSource } from '../types'

export function getPointsType(source: YieldSource): string {
  switch (source) {
    case 'elend':
    case 'evault':
      return 'euler'
    case 'isolated':
      return 'isolated'
    case 'pooled':
      return 'pooled'
    default:
      return 'unknown'
  }
}
